const blueGrey400Color = '#405B68';

export default blueGrey400Color;
